import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions } from '../state';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import TasksModule from '@modules/TasksModule';

function handleTaskAccept(_context: InboxContext, task: ITask): void {
  inboxActions.setSelectedTaskId(task.id);
  TasksModule.setTaskAttribute(task.id, 'isAnswering', true);
  SoftPhoneModule.callControl.answer(task.attributes.callId);
}

export default handleTaskAccept;
